<template>
  <div class="tab-tabela-preco">
    <div class="tab-section">
      <h6 class="section-title">Tabelas de Preço Vinculadas</h6>

      <div v-if="carregando" class="text-center py-3">
        <b-spinner small /> Carregando...
      </div>

      <div v-else-if="associadas.length === 0" class="empty-state">
        <feather-icon icon="AlertCircleIcon" size="18" class="mr-1 text-muted" />
        Nenhuma tabela de preço associada ainda.
      </div>

      <b-table
        v-else
        :items="associadas"
        :fields="campos"
        small
        striped
        responsive
        class="mb-0"
      >
        <template #cell(situacao)="data">
          <b-badge :variant="data.value == 1 ? 'success' : 'secondary'">
            {{ data.value == 1 ? 'Ativo' : 'Inativo' }}
          </b-badge>
        </template>
        <template #cell(dt_manutencao)="data">
          {{ data.value ? new Date(data.value).toLocaleDateString('pt-BR') : '-' }}
        </template>
      </b-table>
    </div>

    <hr />

    <div class="tab-section">
      <h6 class="section-title">Adicionar Tabela de Preço</h6>

      <b-row>
        <b-col cols="8">
          <b-form-group label="Tabela de Preço" label-for="select-tabela-preco">
            <v-select
              id="select-tabela-preco"
              v-model="tabelaSelecionada"
              :options="tabelaOpts"
              :loading="carregandoOpts"
              label="label"
              :reduce="o => o.value"
              placeholder="Pesquise e selecione..."
              :filter-by="filtrar"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4" class="d-flex align-items-end pb-1">
          <b-button
            variant="success"
            :disabled="!tabelaSelecionada || salvando"
            @click="adicionar"
          >
            <b-spinner v-if="salvando" small class="mr-1" />
            <feather-icon v-else icon="PlusIcon" size="14" class="mr-1" />
            Adicionar
          </b-button>
        </b-col>
      </b-row>

      <b-alert v-if="mensagem.texto" :variant="mensagem.tipo" show class="mt-2 mb-0">
        {{ mensagem.texto }}
      </b-alert>
    </div>
  </div>
</template>

<script>
import {
  BTable, BRow, BCol, BFormGroup, BButton, BSpinner, BBadge, BAlert,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import axios from '@/libs/axios';

export default {
  name: 'TabTabelaPreco',
  components: {
    BTable, BRow, BCol, BFormGroup, BButton, BSpinner, BBadge, BAlert, vSelect,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      associadas: [],
      tabelaOpts: [],
      tabelaSelecionada: null,
      carregando: false,
      carregandoOpts: false,
      salvando: false,
      mensagem: { texto: '', tipo: 'success' },
      campos: [
        { key: 'tabelapreco_id', label: 'Cód. Tabela', sortable: true },
        { key: 'situacao', label: 'Situação' },
        { key: 'dt_manutencao', label: 'Dt. Manutenção' },
        { key: 'user_manutencao', label: 'Usuário' },
      ],
    };
  },
  computed: {
    clienteiderp() {
      return this.value?.clienteiderp || null;
    },
  },
  watch: {
    clienteiderp(val) {
      if (val) this.carregar();
    },
  },
  mounted() {
    this.carregarOpts();
    if (this.clienteiderp) this.carregar();
  },
  methods: {
    async carregar() {
      this.carregando = true;
      try {
        const { data } = await axios.get(`/cliente-tabpreco/cliente/${this.clienteiderp}`);
        const lista = Array.isArray(data) ? data : (data.data || data.rows || []);
        this.associadas = lista;
      } catch {
        this.associadas = [];
      } finally {
        this.carregando = false;
      }
    },
    async carregarOpts() {
      this.carregandoOpts = true;
      try {
        const { data } = await axios.get('/tabela-preco', { params: { perPage: 1000 } });
        const lista = Array.isArray(data) ? data : (data.data || []);
        this.tabelaOpts = lista.map(t => ({
          label: `${t.tabelapreco_id} — ${t.tabelapreco_descricao || ''}`,
          value: t.tabelapreco_id,
        }));
      } catch {
        this.tabelaOpts = [];
      } finally {
        this.carregandoOpts = false;
      }
    },
    filtrar(option, label, search) {
      return label.toLowerCase().includes(search.toLowerCase());
    },
    async adicionar() {
      if (!this.tabelaSelecionada || !this.clienteiderp) return;
      this.salvando = true;
      this.mensagem = { texto: '', tipo: 'success' };
      try {
        await axios.post('/cliente-tabpreco', {
          clienteiderp: this.clienteiderp,
          tabelapreco_id: this.tabelaSelecionada,
          situacao: 1,
          dt_manutencao: new Date().toISOString().slice(0, 10),
          user_manutencao: '',
        });
        this.mensagem = { texto: `Tabela "${this.tabelaSelecionada}" associada com sucesso!`, tipo: 'success' };
        this.tabelaSelecionada = null;
        await this.carregar();
      } catch (e) {
        const msg = e?.response?.data?.message || e.message || 'Erro ao associar tabela';
        this.mensagem = { texto: msg, tipo: 'danger' };
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>

<style scoped>
.tab-tabela-preco {
  padding: 0.25rem 0;
}
.tab-section {
  padding: 0.5rem 0;
}
.section-title {
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: #344767;
}
.empty-state {
  display: flex;
  align-items: center;
  color: #6c757d;
  font-size: 0.875rem;
  padding: 0.5rem 0;
}
</style>
